export const PRODUCT_TYPE = Object.freeze({
  MAIN_PRODUCT: 'main_product',
  BUNDLE: 'bundle',
  ADDITIONAL_PRODUCT: 'additional_product',
  ACCESSORY: 'accessory',
  WARRANTY: 'warranty',

  FREE: 'free',
  FREE_MEMBER: 'free_member',
  FREE_HANDRAISER: 'free_handraiser',
  FREE_FULLPAYMENT: 'free_fullpayment',
  FREE_DEPOSIT: 'free_deposit',
  UNSET_FREE: 'unset_free',
  PROMOTION: 'promotion',

  DELIVERY: 'delivery',
  CART_BUNDLE: 'bundle',
})

export default PRODUCT_TYPE
